export default __webpack_public_path__ + "static/media/notification-blue.a4191a1e.svg";